import { useMemo } from "react";
import { useAppSelector } from "@/app/appStore";
import { selectAnnotatedCartItems } from "@/entities/annotation";
import ProductItem from "./product-item";
import { Badge, Box, Flex, ScrollArea } from "@radix-ui/themes";
import CartIsEmpty from "./cart-is-empty";
import { createAnnotatedCartFromTransactions } from "@/features/annotation/lib/helpers";

const AnnotatedCart = () => {
  const annotatedCartItems = useAppSelector(selectAnnotatedCartItems);

  const cartItems = useMemo(() => {
    return createAnnotatedCartFromTransactions(annotatedCartItems);
  }, [annotatedCartItems]);

  const hasNegativeQuantity = useMemo(() => {
    return cartItems.some((item) => item.quantity < 0);
  }, [cartItems]);

  return (
    <Flex direction="column" gap="2" className="h-0 flex-grow">
      {hasNegativeQuantity && (
        <Box py="2" px="1">
          <Badge color="red" variant="soft">
            Annotated cart item(s) have negative quantities
          </Badge>
        </Box>
      )}
      <ScrollArea type="auto" className="h-0 flex-grow">
        <Flex direction="column" gap="2" className="h-0 flex-grow" px="2">
          {cartItems?.length ? (
            cartItems.map(
              ({ name, imageUrl, barcode, skuId, quantity, uom }) => (
                <ProductItem
                  key={skuId}
                  name={name}
                  imageUrl={imageUrl}
                  barcode={barcode}
                  skuId={skuId}
                  quantity={quantity}
                  unitOfMeasurement={uom}
                  isQuantityNegative={quantity < 0}
                />
              )
            )
          ) : (
            <CartIsEmpty />
          )}
        </Flex>
      </ScrollArea>
    </Flex>
  );
};

export default AnnotatedCart;
